const LMS_BASE_URL = process.env.REACT_APP_LMS_BASE_URL;
const CMS_BASE_URL = process.env.REACT_APP_CMS_BASE_URL;
const ADMIN_PANEL_BASE_URL = process.env.REACT_APP_ADMINPANEL_BASE_URL;

export {
  LMS_BASE_URL,
  CMS_BASE_URL,
  ADMIN_PANEL_BASE_URL,
};
